import React from 'react';

import useLanguage from './useLanguage/useLanguage';

import 'i18n';

const Language: React.FC = ({ children }) => {
  const loaded = useLanguage();

  if (!loaded) {
    return null;
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment -- returning children
  return <>{children}</>;
};

export default Language;
